export default __webpack_public_path__ + "static/media/quickplay.b07a6f0b.webp";